/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBookingSlots200, GetApiBookingSlotsQueryParams, GetApiBookingSlotsQueryResponse } from "../entities/GetApiBookingSlots";
import { modelsAvailableSlotsResponseSchema } from "./models/availableSlotsResponseSchema";
import { z } from "zod/v4";

export const getApiBookingSlotsQueryParamsSchema = z.object({
    "service_id": z.coerce.number().int().describe("ID услуги"),
"barber_id": z.optional(z.coerce.number().int().describe("ID мастера")),
"date": z.optional(z.string().describe("Дата (YYYY-MM-DD)")),
"branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiBookingSlotsQueryParams>

/**
 * @description OK
 */
export const getApiBookingSlots200Schema = z.lazy(() => modelsAvailableSlotsResponseSchema) as unknown as z.ZodType<GetApiBookingSlots200>

export const getApiBookingSlotsQueryResponseSchema = z.lazy(() => getApiBookingSlots200Schema) as unknown as z.ZodType<GetApiBookingSlotsQueryResponse>